<div class="main">
    <h5>
        ENHANCE YOUR LEADERSHIP SKILLS,
        <span>OUR PROGRAMS PROVIDE</span>
        THE KNOWLEDGE, TOOLS, AND CREDENTIALS
        <span>YOU NEED TO THRIVE</span>
    </h5>
    <div class="contant">
        <div class="left">
            <img src="../../assets/Screenshot 2025-05-20 173638.png" alt="Enhance Leadership Skills" class="enhance-img">
        </div>
        <div class="right">
            <h3>Get Certified as an Executive Coach & Build a Successful Coaching Business</h3>
            <p>
                Gain a globally recognized ICF certification and the expertise needed to launch, grow, and scale your 
                Executive Coaching practice. Our programs offer comprehensive training, mentorship, and business 
                development strategies to help you become a highly sought-after executive coach.
            </p>
            <ul>
                <li>ICF-Accredited Training</li>
                <li>Flexible Learning Options</li>
                <li>Business Growth Strategies for Coaches</li>
            </ul>
            <p>Take the next step toward a rewarding coaching career today.</p>
            <button class="common-button" routerLink="/program-page">Explore Packages</button>
        </div>
    </div>
</div>
